import React from 'react';
import '../Details.css';
import { Link } from 'react-router-dom';
import Navbar from '../navbar';
import Chart from "react-apexcharts";
import BarChart from './BarChart';
import ChartNavigationBar from './ChartNavigationBar';
import { useEffect, useState,useRef } from 'react';
function PerformanceTracking({periodSelection}) {

  return (
    <div className="details-container-page">
      <BarChart title="Performance Tracking" height={600} periodSelection={periodSelection}  hasAdvancedOptions={true}/>
    </div>
  );
}

export default PerformanceTracking;
